<template>
  <div
    v-if="collapseOptionsMobile.length"
    class="options-content"
  >
    <el-collapse
      v-model="collapseParent"
      class="collapsed"
      accordion
    >
      <el-collapse-item
        v-for="(item, index) in collapseOptionsMobile"
        :key="index"
        :title="item.title"
        :name="item.name"
      >
        <div
          v-if="!item.hasChildCollapse"
        >
          <component
            :is="element.type"
            v-for="(element, i) in item.items"
            :key="i"
            :title="element.title"
            :default="element.default"
            :hint="element.hint"
            :min="element.min"
            :max="element.max"
            :step="element.step"
            :status="element.status"
            :options="element.options"
            :parameter="element.parameter"
            :event-click="element.eventClick"
            @changeOption="changeMobileOption"
          />
        </div>
        <el-collapse
          v-if="item.hasChildCollapse"
          v-model="collapseChildren"
          class="collapsed child-collapse"
          accordion
        >
          <el-collapse-item
            v-for="(itemInner, ikey) in item.collapseChildOptions"
            :key="ikey"
            :title="itemInner.title"
            :name="itemInner.name"
          >
            <div
              v-if="!itemInner.hasChildCollapse"
            >
              <component
                :is="element.type"
                v-for="(element, i) in itemInner.items"
                :key="i"
                :title="element.title"
                :default="element.default"
                :hint="element.hint"
                :min="element.min"
                :max="element.max"
                :step="element.step"
                :status="element.status"
                :options="element.options"
                :parameter="element.parameter"
                :event-click="element.eventClick"
                @changeOption="changeMobileOption"
              />
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SelectInput from '@/widgets/options/SelectInput'
import NumberInput from '@/widgets/options/NumberInput'
import TextInput from '@/widgets/options/TextInput'
import SelectExtendedNum from '@/widgets/options/SelectExtendedNum'
import RadioExtendedNum from '@/widgets/options/RadioExtendedNum'
import RadioExtendedNumText from '@/widgets/options/RadioExtendedNumText'
import SliderInput from '@/widgets/options/SliderInput'
import RadioInput from '@/widgets/options/RadioInput'

export default {
  name: 'MobileOptionsList',
  components: {
    SelectInput,
    NumberInput,
    TextInput,
    SelectExtendedNum,
    RadioExtendedNum,
    RadioExtendedNumText,
    SliderInput,
    RadioInput
  },
  data() {
    return {
      collapseParent: [],
      collapseChildren: [],
      queryChangeParams: [],
    }
  },
  computed: {
    ...mapState(['collapseOptionsMobile', 'clearOptions'])
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.collapseParent = []
        this.collapseChildren = []
        this.queryChangeParams = []
      }
    }
  },
  methods: {
    changeMobileOption (params) {

      this.queryChangeParams = this.queryChangeParams.filter((item) =>
        item.parameter !== params.parameter)

      if (params.value.length) { this.queryChangeParams.push(params) }

      this.$store.dispatch('changeOptionMobile', {
        option: this.queryChangeParams
          .map(item => `${item.parameter}${item.separator}${item.value};`)
          .join(' ')
      })
    }
  }
}
</script>
